import { Locale } from 'modules/i18n';

export const addToWalletButtonTranslation = {
  [Locale.en]: {
    addToWallet: 'Add to wallet',
  },
};
